import React from 'react';

const ventajas = [
    {
        icono: 'ti-shield',
        titulo: 'Resistente a la intemperie',
        descripcion: 'Los modelos con filtro UV conservan su color en exteriores durante todo el año.'
    },
    {
        icono: 'ti-timer',
        titulo: 'Sin mantenimiento',
        descripcion: 'No requiere agua, poda ni fertilizantes para mantener su apariencia.'
    },
    {
        icono: 'ti-layout-grid2',
        titulo: 'Variedad de formatos',
        descripcion: 'Disponible en panel, rollo y presentación expandible para distintos proyectos.'
    },
    {
        icono: 'ti-ruler-pencil',
        titulo: 'Modular y a medida',
        descripcion: 'Los paneles se combinan entre sí para cubrir muros de cualquier dimensión.'
    },
    {
        icono: 'ti-home',
        titulo: 'Interior y exterior',
        descripcion: 'Cada categoría indica el uso recomendado según su material y filtro UV.'
    },
    {
        icono: 'ti-truck',
        titulo: 'Entrega inmediata',
        descripcion: 'Decototal distribuye el producto listo para que lo instales tú o tu equipo de confianza.'
    }
];

const CaracteristicasFollaje = () => {
    return (
        <section>
            <div className="container">
                <div className="card border-0 shadow-sm wow fadeIn" data-wow-delay="100ms">
                    <div className="card-body p-2-3 p-lg-3-0">
                        <div className="row justify-content-center mb-2-5 mb-lg-3-0">
                            <div className="col-lg-10 text-center">
                                <div className="title-style2 mb-0">
                                    <h2 className="h3 h4-lg">Ventajas del follaje artificial</h2>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {ventajas.map((ventaja, index) => (
                                <div key={index} className="col-lg-4 col-md-6 col-12 mb-2-5 mb-md-3-0">
                                    <div className="d-flex align-items-start h-100">
                                        <div className="flex-shrink-0 me-3 me-lg-4">
                                            <i className={`${ventaja.icono} text-primary display-5`}></i>
                                        </div>
                                        <div className="flex-grow-1">
                                            <h3 className="h6 h5-lg mb-2 font-weight-700">{ventaja.titulo}</h3>
                                            <p className="mb-0 text-sm">{ventaja.descripcion}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CaracteristicasFollaje;